import {
  withDefaultContextAsSelectedProject,
  withDefaultContextAsHomeGeo,
} from './api-default-context';

export const getStatementCreationPageDataRequest = () =>
  withDefaultContextAsSelectedProject().get('/tieout/statement/options');

export const getLanguageData = (localeCode) => {
  return withDefaultContextAsHomeGeo()
    .get(`/tieout/translations/languages/${localeCode}`)
    .then((response) => {
      return response.data;
    });
};

export const getUserPreferredLanguage = ({ userId }) => {
  return withDefaultContextAsHomeGeo()
    .get(`/tieout/user/${userId}/languagePreference`)
    .then((response) => response.data);
};

export const fetchSupportedLanguage = () =>
  withDefaultContextAsHomeGeo()
    .get('/tieout/translations/languages')
    .then((response) => {
      return { response: response.data };
    });

export const updateUserPreferredLanguage = ({ languageCode }) =>
  withDefaultContextAsHomeGeo()
    .post(`/tieout/upsertUserPreference?languageCode=${languageCode}`)
    .then((response) => {
      return response;
    });
